let http = 'http://uvp72.ru' ;
let services = http + '/wp-json/wp/v2/posts?categories=2';
let main = http + '/wp-json/wp/v2/posts/132';
let about = http + '/wp-json/wp/v2/posts/96';
let contacts = http+'/wp-json/wp/v2/posts/276';
let maketReq = http+'/wp-json/wp/v2/posts/292';
let vacancy = http+'/wp-json/wp/v2/posts/296';
let mailer = http+'/mailer/mailer.php'

export default {http, services, main, about,contacts, maketReq, vacancy, mailer}